<p-inputNumber
    [styleClass]="'form-control p-0'"
    [formControl]="formControl"
    suffix="°C"
    [min]="to.min"
    [max]="to.max"
    [disabled]="to.disabled"
></p-inputNumber>
